module.exports = __webpack_public_path__ + "static/Feature-3-c3a3ffda611039249b146775aa6d6218.svg";